import React from "react";
import { AcwrDots } from "./AcwrDots";
import { FlagBadge } from "./FlagBadge";
import { InjuryMarker } from "./InjuryMarker";
import { AcwrTooltip } from "./tooltips/AcwrTooltip";
import { FlagTooltip } from "./tooltips/FlagTooltip";

// Pure — the day cell (modal lives elsewhere). Builds tooltips from the structured VM so all
// rendering stays here. DOM/classes copied from StatusTrackerCell's render (minus the Modal).
// `forceClickable` — tagging mode, where a day with no player data can still be tagged.
// `className` — extra classes on the cell root, so a caller can mark a cell (untaggable, say)
// without wrapping it in another element and forcing React to rebuild the cell.
const StatusTrackerCellViewInner = ({ vm, uniqueKey = "", onOpen, forceClickable = false, className = "" }) => {
    // First-load wait: player column + date headers render normally; each cell shows a skeleton
    // (with one placeholder dot per key metric, mirroring the real cell's ACWR dot row).
    if (vm.loading) {
        return (
            <div className="stv2-skeleton-cell">
                <div className="stv2-skeleton-dots">
                    {vm.acwrDots.map((_, i) => (
                        <div key={`sk-dot-${i}`} className="stv2-skeleton-dot" />
                    ))}
                </div>
            </div>
        );
    }

    const acwrTooltip = vm.acwrRows ? <AcwrTooltip rows={vm.acwrRows} /> : null;
    const flagTooltip = vm.hasFlags ? <FlagTooltip groups={vm.flagGroups} uniqueKey={uniqueKey} /> : null;

    return (
        <div
            className={`stv2-tracker-cell${className ? ` ${className}` : ""}`}
            style={{ backgroundColor: vm.backgroundColor }}
            onClick={forceClickable || vm.hasData ? onOpen : undefined}
        >
            <div>
                <InjuryMarker injuries={vm.injuries} uniqueKey={uniqueKey} />
                <FlagBadge count={vm.flagCount} tooltip={flagTooltip} />
            </div>
            <AcwrDots dots={vm.acwrDots} tooltip={acwrTooltip} uniqueKey={uniqueKey} />
        </div>
    );
};

// Every cell holds three antd tooltips, and a page is 50 players by a month of days. Memoised
// so a context change that leaves a cell's props alone does not re-render all of them.
export const StatusTrackerCellView = React.memo(StatusTrackerCellViewInner);
